import { ContentBox } from "@msuite/ui/app-shell";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { columns } from "./table-config";
import { TourWavesMenu } from "./tour-waves-menu";

export function TourWaves() {
	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["tour-waves"],
		queryFn: async () => {
			const response = await client.stock["tour-waves"].$get();
			const data = await responseHandler(response);
			return guardArray(data.tourWaves);
		},
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={data}
				columns={columns}
				isLoading={isLoading}
				refetch={refetch}
				queryKey={queryKey}
				menu={<TourWavesMenu />}
				persistenceKey="tour-waves-table"
			/>
		</ContentBox>
	);
}
